import { AppLayout } from '../../../components/layouts';
import PageHeader from '../../../components/dashboard/PageHeader';
import Reports from '../home/Reports';

export default function ReportsPage() {
    return (
        <AppLayout>
            <PageHeader
                title="Reports"
                subtitle="Review progress reports shared by teachers for your children."
            />
            <div className="rounded-[22px] border border-[#efe6f1] bg-white p-4 shadow-[0_12px_40px_rgba(136,22,122,0.05)] sm:p-6 min-h-[320px] relative">
                <Reports />
            </div>
        </AppLayout>
    );
}
